import React, {useRef} from 'react'
import { useTable } from 'react-table'

export const ScheduleMatrixTable = ({ columns, data, renderMatrixSettings }) => {
    const tableContent = useRef(null);
    const tableHeader = useRef(null);

    const setScrollStateFromBody = () => {
        window.requestAnimationFrame(() => {
            const scrollLeft = tableContent.current.scrollLeft;
            tableHeader.current.scrollLeft = scrollLeft;
        })
    }

    const MatrixSettings = () => {
        return renderMatrixSettings
    }

    const {
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable(
        {
            columns,
            data,
        },
    )

    return (
        <div className={"table-container"}>
            <div className={"table-controls"}>
                <MatrixSettings />
            </div>
            <table role={"table"}>
                <thead ref={tableHeader} >
                {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map(column => (
                            <th {...column.getHeaderProps()}>
                                {column.render('Header')}
                            </th>
                        ))}
                    </tr>
                ))}
                </thead>
                <tbody {...getTableBodyProps()}
                       onScroll={setScrollStateFromBody}
                       ref={tableContent}
                       >
                {rows.map((row, i) => {
                    prepareRow(row)
                    return (
                        <tr {...row.getRowProps()}>
                            {row.cells.map((cell, index) => {
                                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                            })}
                        </tr>
                    )
                })}
                </tbody>
            </table>
        </div>
    )
}


